import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable,BehaviorSubject, EMPTY, throwError } from 'rxjs';
import { map,catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CookieService  } from 'ngx-cookie-service';
import { AuthService } from './auth.service';
import { TenantService } from './tenant.service';


@Injectable({
  providedIn: 'root'
})
export class WidgetSettingsService {
	tetent: string = '';
  	tenantLocId: any = '';
  	confiGurationSetting: string = '*';
  	  constructor(private http: HttpClient, private cookieService: CookieService, private authService: AuthService, private tenantService: TenantService) {
    this.tetent = this.tenantService.tenant;
    this.confiGurationSetting = this.tenantService.configurationSetting;
  }


  	private readonly apiUrl = environment.apiUrl;

    newInPopularSetting(viewType, listSize, wid, auth) : Observable<any> { 
      this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/new?id='+wid,{ "view" : viewType,"size" : listSize},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  popularTitlesSetting(viewType, listSize, wid, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/popular?id='+wid,{ "view" : viewType,"size" : listSize},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  recommendedForYouSetting(viewType, listSize, fallback, showPopularWithPrompt, wid, auth) : Observable<any> {
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/recommended?id='+wid,{ "view" : viewType,"size" : listSize,"fallback" : fallback,"showPopularWithPrompt" : showPopularWithPrompt},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  resourseListSetting(viewType, listSize, wid, wlid, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/resourcelist?id='+wid,{"view" : viewType,"size" : listSize,"listId" : wlid},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  resourseListsSetting(listSize, wid, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/resourcelists?id='+wid,{ "size" : listSize},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  recentReviewsSetting(viewType, listSize, wid, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/reviews?id='+wid,{ "view": viewType,"size": listSize},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  linksSetting(viewType, captionW, wid, links, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/links?id='+wid,{ "width": viewType,"caption": captionW, "links" : links},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  bulletinListSetting(viewType, listSize, wid, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/bulletinlist?id='+wid,{ "width": viewType,"size": listSize},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  bulletinSetting(viewType, bid, wid, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/bulletin?id='+wid,{ "width": viewType,"bulletinId": bid},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  calendarSetting(viewType, messagec, wid, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/calendar?id='+wid,{ "width": viewType,"message": messagec},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  exploreViewSetting(viewType,pageId, wid, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json', 'Authorization':'Bearer '+auth});
    return this.http.post(this.apiUrl+'widget/settings/explore?id='+wid,{ "width": viewType, "pageId": pageId},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  locationHoursSetting(viewType, LocationMap, LocationText, wid, hours, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/locationhours?id='+wid,{ "width":viewType, "locationText": LocationText, "mapLink": LocationMap, "days": hours},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  messageSetting(wid, viewType, content,caption, auth) : Observable<any> { 
    // var auth:any = 'null';
    // if(this.cookieService.check( 'info')){
    //if (localStorage.getItem('info') != null){
    //   var auth:any =  'Bearer '+localStorage.getItem('token');
    // }
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/settings/message?id='+wid,{ "caption": caption, "width": viewType, "content": content},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  qaSetting(caption, wid, quesAns, image, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
      //"images/qa-book.png"
    return this.http.post(this.apiUrl+'widget/settings/qa?id='+wid,{ "caption": caption, "img":image, "questions": quesAns},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }
  
  qaViewSetting(caption, quesAns, image, auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
      //"images/qa-book.png"
    return this.http.post(this.apiUrl+'widget/settings/qa?id=',{ "caption": caption, "img":image, "questions": quesAns},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  getResourcesList() : Observable<any> { 
     var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization': auth });
    //return this.http.get(this.apiUrl+'resource/list',{headers})
    return this.http.get(this.apiUrl+'widget/ResourceLists?size=999',{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  getExplorePages() : Observable<any> { 
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization': auth });
    return this.http.get(this.apiUrl+'explore/pagelist',{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  bulletinList() : Observable<any> { 
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization': auth });
    return this.http.get(this.apiUrl+'bulletin',{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  getQaImage() : Observable<any> { 
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization': auth });
    return this.http.get(this.apiUrl+'widget/qa/images',{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  logoListGet(auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization':'Bearer '+auth });
    return this.http.get(this.apiUrl+'setting/logo/all',{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  bannerListGet(auth) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization':'Bearer '+auth });
    return this.http.get(this.apiUrl+'setting/bannerimage/all',{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }


  logoUpload(auth,formData) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'setting/logo/upload',formData,{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  qaImageUpload(auth,formData) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'widget/qa/image/upload',formData,{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }
  bannerUpload(auth,formData) : Observable<any> { 
    this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'setting/bannerimage/upload',formData,{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  saveLogoSection(shows,line1,line2,image,auth) : Observable<any> { 
      this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'setting/banner/logo',{"img": image,"line1": line1, "line2":line2},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }
  saveBannerSection(line1,line2,image,isSmall,auth) : Observable<any> { 
      this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary' : this.tenantLocId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.post(this.apiUrl+'setting/banner/main',{"img": image,"line1": line1,"line2": line2, "bannerSize":isSmall},{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }

  deleteWidgets(id,auth) : Observable<any> { 
      this.tenantLocId = this.cookieService.get('selectedlocation'+this.tetent);
      let headers = new HttpHeaders({'app-id' : 'opac','tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization':'Bearer '+auth });
    return this.http.delete(this.apiUrl+'widget/settings/delete/'+id,{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
  }
  public handleError(error: any) {
    console.log("error", error);
    if (error.status == 401) {
        this.authService.logoutSubject.next(true);
      return EMPTY;
    } else {
      return throwError(error);
    }
  }
  

}
